import api from './api';
import { unwrapList } from './unwrapList';

export interface Campaign {
    id: number;
    name: string;
    type: string;
    status: string;
    created_at: string;
}

export const campaignService = {
    getCampaigns: async (): Promise<Campaign[]> => {
        const response = await api.get('/campaigns');
        return unwrapList<Campaign>(response.data);
    },

    createCampaign: async (name: string, type: string = 'lookbook'): Promise<Campaign> => {
        const response = await api.post('/campaigns', { name, type });
        return (response.data as any).data;
    }
};

export default campaignService;
